const APIS = {
  GET_APP_CATEGORIES: 'api/AppManager/GetAppCategories',
};

export default APIS;
